import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SingleTitlehAnimation from '../../animations/SingleTitle';
GSAP.registerPlugin(ScrollTrigger);

import each from 'lodash/each';

export default class ReprSection extends Component {
	constructor() {
		super({
			element: '.repr',
			elements: {
				titles: 'repr__title'
			}
		});
	}

	create() {
		super.createComponent();

		this.createTimeline();
	}

	createTimeline() {
		if (window.isMobile) return;

		this.allTitlesAnimations = [];
		each(this.elements.titles, (title) => {
			const titleAnimation = new SingleTitlehAnimation({
				element: title,
			});
			this.allTitlesAnimations.push(titleAnimation);
		});
	

		// this.paragraphAnimation = new ParagraphAnimation({
		// 	element: this.element,
		// });

		// this.paragraphAnimation.animateOut();

		ScrollTrigger.create({
			trigger: this.element,
			start: 'top 80%',
			end: 'bottom 20%',
			onEnter: () => this.animateIn(),
			onEnterBack: () => this.animateIn(),
			onLeave: () => this.animateOut(),
			onLeaveBack: () => this.animateOut(),
		});
	}

	animateIn() {
		each(this.allTitlesAnimations, (titleAnimation) => {
			titleAnimation.animateIn();
		});
	}
	
	animateOut() {
		each(this.allTitlesAnimations, (titleAnimation) => {
			titleAnimation.animateOut();
		});
	}

	clearTimeline() {}

	destroy() {
		super.destroy();
		this.clearTimeline();
	}
}
